import React from 'react';
import { IdentityTabKey } from './IdentityTabs';
import IdentityPositionsBody from './IdentityPositionsBody';
import IdentityProcessesBody from './IdentityProcessesBody';
import IdentityPlaceholderBody from './IdentityPlaceholderBody';
import MyLeaveBalancesBody from './MyLeaveBalancesBody';
import Drawer from '../../../components/common/Drawer';
import '../../../components/layout/ModuleLayout.css';

interface Posting {
  id: number;
  title: string;
  geography: string;
  type: string;
}

interface SOP {
  id: number;
  name: string;
  role: string;
  description: string;
  frequency: string;
  lastUpdated?: string;
}

interface Scope {
  sops: SOP[];
  risks: {
    id: number;
    name: string;
    level: string;
    role: string;
    mitigation: string;
  }[];
  compliances: {
    id: number;
    name: string;
    role: string;
    frequency: string;
    authority: string;
  }[];
}

interface User {
  name: string;
  empId: string;
  email: string;
  dept: string;
  avatar: string;
}

interface IdentityNetBodyProps {
  activeTab?: IdentityTabKey;
  user: User;
  postings: Posting[];
  scope: Scope;
  asideOpen?: boolean;
  onAsideToggle?: () => void;
}

const IdentityNetBody: React.FC<IdentityNetBodyProps> = ({
  activeTab = 'positions',
  user,
  postings,
  scope,
  asideOpen = false,
  onAsideToggle,
}) => {
  const renderPanel = () => {
    switch (activeTab) {
      case 'positions':
        return <IdentityPositionsBody user={user} postings={postings} />;
      case 'processes':
        return <IdentityProcessesBody sops={scope.sops} />;
      case 'compliances':
        return <IdentityPlaceholderBody />;
      case 'risks':
        return <IdentityPlaceholderBody />;
      case 'leave_balances':
        return <MyLeaveBalancesBody />;
      default:
        return null;
    }
  };

  return (
    <div className="module-layout">
      <div className="module-main">
        <div className="tab-content">
          <section role="tabpanel" className="tab-panel show">
            {renderPanel()}
          </section>
        </div>
      </div>
      <Drawer isOpen={asideOpen} onClose={onAsideToggle ?? (() => {})}>
        <div className="aside-card">
          <h3>Identity Overview</h3>
          <p>• <strong>Positions</strong> — Functional roles</p>
          <p>• <strong>Processes</strong> — SOPs you own</p>
          <p>• <strong>Compliances</strong> — Obligations</p>
          <p>• <strong>Risks</strong> — Risk accountability</p>
        </div>
        <div className="aside-card">
          <h3>Your Profile</h3>
          <p>• <strong>Positions</strong> — {postings.length} roles</p>
          <p>• <strong>SOPs</strong> — {scope.sops.length} processes</p>
          <p>• <strong>Risks</strong> — {scope.risks.length} items</p>
        </div>
      </Drawer>
    </div>
  );
};

export default IdentityNetBody;
